<template>
  <div class="article">
    <div class="article_back" @click="goNews"> 返回列表 </div>
    <div class="article_title">工信部发声 促进民营经济发展壮大</div>
    <div class="article_time">发布于2021年2月31日 </div>
    <div  class="article_con"  >
      
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
        id:''
    }
  },
  computed: {},
  watch: {},
  created () {
    this.id = this.$route.query.id
  },
  mounted () {},
  methods: {
    goNews(){
        this.$router.push('/pc/News')
    }
  }
}
</script>

<style scoped >
.article{
    margin: auto;
    width:1200px
}
.article_back{
    text-decoration: underline;
    color:rgb(26, 127, 221) ;
    cursor: pointer;
    margin-top: 100px;
}    
.article_title{
    width: 100%;
    text-align: center;
    font-size: 30px;
    margin: 20px 0 10px 0;

}
.article_time{
    width: 100%;
    text-align: center;
   color: #ccc;
   font-size: 16px;

}
.article_con{
    margin-top: 20px;
}
</style>
